<template>
<section class="date-range">
  <el-select
    v-model="quarters"
    multiple
    size="small"
    style="width:113px;"
    @change="onSelectChanged"
  >
    <el-option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :label="option.label"
    />
  </el-select>

  <compare-time-year @on-years-changed="onYearsChanged" />
</section>
</template>

<script>
import CompareTimeYear from './Year'
export default {
  name: 'CompareTimeQuarter',
  components: {CompareTimeYear},
  props: {
    query: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      quarters: [1]
    }
  },
  computed: {
    options: () => [{
      value: 1,
      label: '第一季度'
    }, {
      value: 2,
      label: '第二季度'
    }, {
      value: 3,
      label: '第三季度'
    }, {
      value: 4,
      label: '第四季度'
    }]
  },
  methods: {
    onSelectChanged () {
      this.setQuery()
    },
    onYearsChanged (years) {
      this.years = years
      this.setQuery()
    },
    setQuery () {
      let {years, quarters, query} = this

      if (!Array.isArray(years) || years.length === 0 || !Array.isArray(quarters) || quarters.length === 0) {
        query.queryTimes = []
        this.$emit('select-changed', false)
        return
      }

      query.queryTimes = years.reduce((list, year) => quarters.reduce((list, quarter) => {
        list.push(`${year}年${quarter}季度`)
        return list
      }, list), [])

      this.$emit('select-changed', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-range {
  display: inline-block;

  .el-select {
    /deep/ {
      .el-select__tags {
        height: 32px;
        align-items: center;
        flex-wrap: nowrap;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/CompareTime/Quarter.vue